import styled from "react-emotion"
import PropTypes from "prop-types"
import WithMargin from "./WithMargin"

const WithMarginAndPadding = styled(WithMargin)`
    padding: ${props => props.theme[props.padding || ""]};
    ${props =>
        props.paddingRight &&
        `
        padding-right: ${props.theme[props.paddingRight]};
    `};
    ${props =>
        props.paddingLeft &&
        `
        padding-left: ${props.theme[props.paddingLeft]};
    `};
    ${props =>
        props.paddingTop &&
        `
        padding-top: ${props.theme[props.paddingTop]};
    `};
    ${props =>
        props.paddingBottom &&
        `
        padding-bottom: ${props.theme[props.paddingBottom]};
    `};
`

WithMarginAndPadding.propTypes = {
    ...WithMargin.propTypes,
    padding: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    paddingRight: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    paddingLeft: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    paddingTop: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    paddingBottom: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
}
WithMarginAndPadding.displayName = "WithMarginAndPadding"

export default WithMarginAndPadding



// WEBPACK FOOTER //
// ./src/ui/utils/WithMarginAndPadding.js